import { Component, input, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner',
  imports: [CommonModule],
  templateUrl: './spinner.html',
})
export class SpinnerComponent {
  isVisible = input<boolean>(false);
  message = input<string>('Cargando...');
}
